import { Box } from '@factorialco/deprecated-design-system'
import { F0Text } from '@factorialco/f0-react'
import { NodeProps } from '@xyflow/react'

import { InjectHoverProvider } from 'modules/core/lib/hoverContext'

import Checkbox from 'modules/job_catalog/components/DevJobCatalogTree/components/Checkbox'
import {
  getNodeBackgroundColor,
  getNodeBorderColor,
} from 'modules/job_catalog/components/DevJobCatalogTree/treeUtils'
import { type CustomLevelNode, SIZES } from 'modules/job_catalog/components/DevJobCatalogTree/types'

const JobCatalogLevelNode = (props: NodeProps<CustomLevelNode>) => {
  return (
    <InjectHoverProvider>
      <Box
        borderRadius={{ all: 'abs012' }}
        background={getNodeBackgroundColor(props.data.checked)}
        style={{ width: `${SIZES.NODE_WIDTH}px`, height: `${SIZES.NODE_LEVEL_HEIGHT}px` }}
        flexDirection="row"
        paddingX="s12"
        justifyContent="spaceBetween"
        alignItems="center"
        border={{
          all: {
            color: getNodeBorderColor(props.selected, props.data.checked),
            style: 'solid',
            width: 's1',
          },
        }}
      >
        <F0Text content={props.data.name} variant="label" ellipsis />
        <Checkbox
          nodeId={props.id}
          checked={props.data.checked}
          disabled={props.data.multiselectDisabled}
        />
      </Box>
    </InjectHoverProvider>
  )
}

export default JobCatalogLevelNode
